// extracted by mini-css-extract-plugin
export default {"invalidDataError":"Tax_invalidDataError__0o+5+"};